import React, { useEffect, useState } from "react";
import { NightguardForm, NightGuardProps } from "../../../types/UploadFieldsType";
import TextInput from "../formComp/TextInputOld";
import SelectInput from "../formComp/SelectInputOld";

const NightGuard: React.FC<NightGuardProps> = ({ onChange }) => {
  const [form, setForm] = useState<NightguardForm>({
    neededFor: "",
    margin: "",
    occlusalSurface: "",
    thickness: "",
  });

  const handleChange = (field: keyof NightguardForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    onChange(form);
  }, [form, onChange]);

  return (
    <div className="w-full text-sm md:text-lg text-gray-900">
      <h2 className="font-bold mb-4 border-b-2 border-[#2fa9bf]">
        NIGHTGUARD / BITE SPLINT
      </h2>

      <div className="w-[100%] md:w-[90%]">
        <SelectInput
          label="Design needed for:"
          name="neededFor"
          value={form.neededFor}
          onChange={(e) => handleChange("neededFor", e.target.value)}
          options={[
            { value: "Simple nightguard - full coverage", label: "Simple nightguard - full coverage" },
            { value: "Michigan splint", label: "Michigan splint" },
            { value: "Bleaching tray", label: "Bleaching tray" },
            { value: "Other - please specify", label: "Other - please specify" },
          ]}
        />

        <TextInput
        para="Amount of tooth and gingiva to be covered"
          label="Margin of splint"
          name="margin"
          value={form.margin}
          onChange={(e) =>
            handleChange("margin", e.target.value)
          }
        />

        <SelectInput
        optional
          label="Occlusal surface of splint"
          name="occlusalSurface"
          value={form.occlusalSurface}
          onChange={(e) => handleChange("occlusalSurface", e.target.value)}
          options={[
            { value: "Flat", label: "Flat" },
            { value: "Follow occlusal anatomy", label: "Follow occlusal anatomy" },
          ]}
        />

        <TextInput
          label="Desired thickness of splint"
          name="thickness"
          value={form.thickness}
          onChange={(e) => handleChange("thickness", e.target.value)}
        />
      </div>
    </div>
  );
};

export default NightGuard;
